
import { EEventType, IEventsMap, TLandingUIProperties } from './plugins/clickstream/models';
import { signinUiProperties } from './plugins/clickstream/uiProperties';
import { IClientSendV2 } from '@mm-frontend/clickstream-client-js/types/lib';
import clickStream from './plugins/clickstream';
import { getExtractedUTMParamsFromURL } from './utils';

function sendEventToClickstream<T extends keyof IEventsMap>(params: {
  event: T,
  eventParameters?: IEventsMap[T],
  prefix?: string,
}) {
  const eventPrefix = params.prefix ? `_${params.prefix}` : '';
  const uiPropertyKey = `${params.event}` + eventPrefix as keyof TLandingUIProperties;

  clickStream.sendV2({
    event: params.event,
    payload: {
      eventParameters: params.eventParameters || null,
      uiProperties: signinUiProperties[uiPropertyKey],
    },
  } as IClientSendV2<T, IEventsMap[T]>);
}

export function sendPageViewEvent() {
  const utmParams = getExtractedUTMParamsFromURL();
  sendEventToClickstream({
    event: EEventType.PAGE_VIEW,
    eventParameters: utmParams,
  });
};

export function handleLinkClicks() {
  const eventLinksNodeList = document.querySelectorAll<HTMLLinkElement>('a[data-event]');
  const eventLinksArray = Array.from(eventLinksNodeList);

  eventLinksArray.forEach((link) => {
    const event = link.dataset.event as EEventType;
    const prefix = link.dataset.prefix || '';

    // Проверяем, является ли event ключом IEventsMap
    link.addEventListener('click', () => sendEventToClickstream({ event: event as keyof IEventsMap, prefix }));
  });
}
export function sendEventOnScrollToElement() {
  const eventItemsNodeList = document.querySelectorAll<HTMLElement>('[data-scroll]');
  const eventItemsArray = Array.from(eventItemsNodeList);

  eventItemsArray.forEach((item) => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const event = item.dataset.scroll as EEventType | undefined;
            if (!event) return; // Если атрибута нет, выходим

            const prefix = item.dataset.prefix || '';
            sendEventToClickstream({ event: event as keyof IEventsMap, prefix });

            obs.unobserve(item); // Отключаем только для текущего элемента
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(item);
  });
}
export function handleButonClicks() {
  const eventButtonsNodeList = document.querySelectorAll<HTMLButtonElement>('button[data-event]');
  const eventButtonsArray = Array.from(eventButtonsNodeList);
  eventButtonsArray.forEach((eventNode) => {
    const event = eventNode.dataset.event as EEventType;
    const prefix = eventNode.dataset.prefix || '';
    eventNode.addEventListener('click', () => sendEventToClickstream({ event: event as keyof IEventsMap, prefix }));
  });
}

export function handleScrollToFooter() {
  const footer = document.querySelector<HTMLElement>('footer')!;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        sendEventToClickstream({ event: EEventType.SCROLL_ALL });
        observer.unobserve(entry.target);
      }
    });
  });

  observer.observe(footer);
}
